export default __webpack_public_path__ + "static/media/cash.026e1ebd.png";